import type { FC } from 'react'

import type { GridProps as BaseGridProps } from '@mui/material/Grid'
import BaseGrid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'

type GridProps = BaseGridProps & {
  columnWidth?: string
}

const StyledGrid = styled(BaseGrid)<GridProps>(({
  theme,
  spacing = 0,
  columnWidth = '300px',
}) => {
  return {
    '--columnWidth': columnWidth,
    display: 'grid',
    gridTemplateColumns: `repeat(auto-fit, calc(${columnWidth} + ${theme.spacing(
      parseInt(`${spacing}`, 0),
    )}))`,
    gridAutoRows: '1fr',
    '& > div': {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    '& > div > div:first-of-type': {
      height: '100%',
    },
  }
})

export const Grid: FC<GridProps> = ({ ...props }) => <StyledGrid {...props} />
